import React, { Component } from "react";
import { Row, Col, Button, Form, Select, message, Input, Checkbox } from "antd";
import "./StakeHolder.css";
import { withRouter } from "react-router-dom";
import { API } from "../../../API/API";
import FileDownload from "js-file-download";
const { TextArea } = Input;
class StakeHolderDoc extends Component {
  formRef = React.createRef();
  state = {
    data: [],
    invitationid: this.props.invitationid,
    vendorid: this.props.vendorid,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get(
      "/getTenderDocJoinList?invitationid=" +
        this.state.invitationid +
        "&vendorid=" +
        this.state.vendorid
    ).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        this.setState({
          data: response.data.retData,
        });
      }
    });
  };
  onDownLoadFile = (sourceid, sourcetype, filename) => {
    API.get("/download?sourceid=" + sourceid + "&sourcetype=" + sourcetype, {
      responseType: "blob",
    }).then((response) => {
      if (response.status === 200) {
        FileDownload(response.data, filename);
      }
    });
  };
  render() {
    return (
      <div id="stakeholder">
        {this.state.data.map((el, index) => (
          <div>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div className="Label">Файл {index + 1} {el.requirevalue ? " /" + el.requirevalue + "/" : ""}</div>
                <Button
                  style={{
                    fontWeight: "500",
                    color: "#0358A7",
                    textAlign: "start",
                    width: "100%",
                  }}
                  onClick={() =>
                    this.onDownLoadFile(el.sourceid, el.sourcetype, el.filename)
                  }
                  type="default"
                >
                  {el.filename}
                </Button>
              </Col>
            </Row>
          </div>
        ))}
      </div>
    );
  }
}

export default withRouter(StakeHolderDoc);
